import React, { useContext, useState } from "react";
import img1 from "../assets/images/caller.avif";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { Store } from "../context/store";
import ClipLoader from "react-spinners/ClipLoader";
import apiRequest from "../utils/apiRequest";
import Toast from "react-bootstrap/Toast";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function Call({ show, onShowChange, hideSection = false }) {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  const [internalShow, setInternalShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [name, setName] = useState("");
  const [referrer, setReferrer] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const type = "appointment";
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const isControlled = typeof show === "boolean";
  const modalShow = isControlled ? show : internalShow;
  const handleClose = () =>
    isControlled ? onShowChange?.(false) : setInternalShow(false);
  const handleShow = () =>
    isControlled ? onShowChange?.(true) : setInternalShow(true);
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const tomorrowFormatted = tomorrow.toISOString().split("T")[0];

  const bookAppointment = async () => {
    setLoading(true);
    const trimmedName = name.trim();
    const trimmedPhone = phone.trim();

    // Validate fields before making the API call
    const validationErrors = [];
    if (!trimmedName) {
      validationErrors.push("Name is required. ");
    }
    if (!fromDate || !toDate) {
      validationErrors.push(
        "Please select a date range for your appointment. This helps us schedule a time that works for both you and our office."
      );
    }
    if (!trimmedPhone) {
      validationErrors.push("Phone number is required. ");
    }

    if (validationErrors.length > 0) {
      setLoading(false); // Reset loading state on validation failure
      setError(validationErrors); // Set error message with all errors combined
      setShow1(true);
      return; // Exit the function early to prevent API call
    }
    try {
      const url = `${baseUrl}/appointment`;
      const body = { name, fromDate, toDate, phone, message, type };
      if (referrer.trim() !== "") {
        body.referrer = referrer.trim();
      }
      const data = await apiRequest(url, "POST", body, null);
      setName("");
      setReferrer("");
      setFromDate("");
      setToDate("");
      setPhone("");
      setMessage("");
      setError(data.message);
      setShow1(true);
      handleClose();
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Toast section */}
      <div className="toast-container">
        <Toast
          onClose={() => setShow1(false)}
          show={show1}
          delay={4000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">{error}</strong>
          </Toast.Header>
        </Toast>
      </div>

      {/* <!-- Call to Action Start --> */}
      {!hideSection && (
        <section className="cta-section">
          <div className="container-xxl">
            <div className="container">
              <div className="cta-shell">
                <div className="cta-content wow fadeIn" data-wow-delay="0.1s">
                  <span className="cta-eyebrow">Connect with us</span>
                  <h2 className="cta-title">
                    Get direct support from our real estate team.
                  </h2>
                  <p className="cta-lead">
                    Reach out to our dedicated office desk during business
                    hours, 9am to 5pm WAT, for personalized assistance and
                    expert guidance.
                  </p>
                  <div className="cta-actions">
                    <a className="cta-action cta-primary" href="tel:+2349152415476">
                      <i className="fa fa-phone-alt"></i>
                      <span>Make a call</span>
                    </a>
                    <a
                      className="cta-action cta-whatsapp"
                      target="_blank"
                      rel="noreferrer"
                      href="https://wa.me/+2349152415476?text=I'm%20interested%20in%20inquiring%20about%20properties%20from%20your%20website"
                    >
                      <i className="fab fa-whatsapp"></i>
                      <span>WhatsApp</span>
                    </a>
                    <Link className="cta-action cta-ghost" to="/contact#feedback">
                      <i className="fa fa-comment-dots"></i>
                      <span>Feedback</span>
                    </Link>
                    <button
                      type="button"
                      className="cta-action cta-ghost"
                      onClick={handleShow}
                    >
                      <i className="fa fa-calendar-alt"></i>
                      <span>Book a site visit</span>
                    </button>
                  </div>
                  <div className="cta-metrics">
                    <div className="cta-metric">
                      <span>Average response</span>
                      <strong>Under 10 minutes</strong>
                    </div>
                    <div className="cta-metric">
                      <span>Availability</span>
                      <strong>Mon - Sat, 9am - 5pm</strong>
                    </div>
                  </div>
                </div>
                <div className="cta-media wow fadeIn" data-wow-delay="0.3s">
                  <img src={img1} alt="Customer support" />
                  <div className="cta-card">
                    <div>
                      <span>Need a guided tour?</span>
                      <strong>Schedule a site visit today.</strong>
                    </div>
                    <button type="button" onClick={handleShow}>
                      Book now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* <!-- Call to Action End --> */}

      {/* modal */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={handleClose}
        dialogClassName="cta-modal"
        contentClassName="cta-modal-content"
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="text-primary"
            style={{ textAlign: "center", width: "100%" }}
          >
            Book Site Appoinment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FloatingLabel
              controlId="floatingInput"
              label="Full Name"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Enter your Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel controlId="floatingPhone" label="Phone Number">
              <Form.Control
                type="tel"
                placeholder="Phone Number"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </FloatingLabel>

            <Row className="justify-content-between">
              <Col md={6}>
                <Form.Group controlId="formStartDate" className="my-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={tomorrowFormatted}
                    required
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formEndDate" className="my-3">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    min={tomorrowFormatted}
                    required
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <FloatingLabel controlId="floatingTextarea2" label="Message">
              <Form.Control
                as="textarea"
                placeholder="Leave a message here"
                style={{ height: "100px" }}
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </FloatingLabel>

            <FloatingLabel
              controlId="floatingInput"
              label="Referrer's Name (if any)"
              className="mt-3"
            >
              <Form.Control
                type="text"
                required
                value={referrer}
                onChange={(e) => setReferrer(e.target.value)}
              />
            </FloatingLabel>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={bookAppointment}
            disabled={loading}
            style={{ minWidth: "150px" }}
          >
            {loading ? (
              <ClipLoader size={20} color={"#fff"} />
            ) : (
              "Book Appoinment"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Call;
